import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SearchLogo from "src/assets/Search";
import { useTable, useSortBy, useGlobalFilter, useAsyncDebounce, usePagination } from "react-table";
import clsx from "clsx";
import UpArrowIcon from "src/assets/UpArrow";
import ForwardRight from "src/assets/ForwardRight";
import ArrowRight from "src/assets/ArrowRight";
import Select from "react-select";
import { loadOrders, loadConfig, loadJob } from "src/redux/actions/square";
import Alert from "src/components/Alert";
import customSelectTheme from "src/utils/selectTheme";
import ServerPaginationTable from "src/components/ServerPaginationTable";
import SyncStatus from "src/components/SyncStatus";
import getSymbolFromCurrency from "currency-symbol-map";
import { migrateSquareDataForOrders } from "src/api";
import { addToast } from "src/redux/actions/toasts";

function Orders() {
  const [syncStatus, setSyncStatus] = useState("enabled");
  const orders = useSelector((state) => state.square.orders);
  const accounts = useSelector((state) => state.square.accounts);
  const dispatch = useDispatch();
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);
  const [status, setStatus] = useState([]);
  const [sortBy, setSortBy] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(loadConfig());
    dispatch(loadOrders());
  }, []);

  

  const data = useMemo(() => orders.data, [orders]);

  const columns = useMemo(
    () => [
      {
        Header: "Order ID",
        accessor: "cartInvoiceId",
      },
      {
        Header: "Order Date",
        accessor: "orderDate",
        disableSortBy: true,
      },
      {
        Header: "Customer Name",
        accessor: "customerName",
      },
      {
        Header: "Customer Email",
        accessor: "customerEmail",
      },
      {
        Header: "Total Amount",
        accessor: "totalAmount",
        Cell: ({ cell: { row } }) => (
          <span>
            {row.original.totalAmount && getSymbolFromCurrency(row.original.currency)}{" "}
            {row.original.totalAmount}
          </span>
        ),
        className: "text-right",
      },
      {
        Header: "Deskera Invoice Code",
        accessor: "deskeraDocumentCode",
      },
      {
        Header: "Payment Status",
        accessor: "paymentStatus",
        Cell: ({ cell: { row } }) => {
          return (
            <SyncStatus
              status={row.original.paymentStatus}
              id={row.original.cartInvoiceId}
            />
          );
        },
        disableGlobalFilter: true
      },
      {
        Header: "Fulfillment Status",
        accessor: "fulfillStatus",
        Cell: ({ cell: { row } }) => {
          return (
            <SyncStatus
              status={row.original.fulfillStatus}
              id={row.original.cartInvoiceId}
            />
          );
        },
        disableGlobalFilter: true,
      },
      {
        Header: "Sync Status",
        accessor: "syncStatus",
        Cell: ({ cell: { row } }) => {
          return (
            <SyncStatus
              status={row.original.syncStatus}
              reason={row.original.reason}
              id={row.original.cartInvoiceId}
            />
          );
        },
        disableGlobalFilter: true,
      },
      {
        Header: "Sync Remarks",
        accessor: "reason",
        disableSortBy: true,
        Cell: ({ cell: { row } }) => {
          return <>{!(row.original.syncStatus === "SUCCESSFUL") && row.original.reason}</>;
        },
      },
    ],
    []
  );

  const config = useSelector((state) => state.square.config);

  useEffect(() => {
    setLoading(false);
    if (data && data.totalPages) {
      setPageCount(data.totalPages);
    }
  }, [data]);

  const refreshData = ({ pageSize, pageIndex, status, sortBy, search }) => {
    setPageSize(pageSize);
    setPageIndex(pageIndex);
    setStatus(status);
    setSortBy(sortBy);
    setLoading(true);
    dispatch(loadOrders(pageSize, pageIndex, status, sortBy, search ?? ""));
  };


  return (
    <div className="p-4">
      <h3 className="mb-3">Orders</h3>
      {(!config.data || !config.data.syncEnabled || !accounts.data[0]?.squareTokenPresent) && (
        <Alert type="warning">
          Your synced orders will appear here. Please complete{" "}
          <Link to="/app/square" className="text-alert-warning">
            <u>Setup</u>
          </Link>{" "}
          before continuing.
        </Alert>
      )}
      <ServerPaginationTable
        data={data.content ? data.content : []}
        columns={columns}
        migrate={migrateSquareDataForOrders}
        cart="square"
        refresh={refreshData}
        tab="Orders"
        pageCount={pageCount}
        loading={loading}
        rowId="id"
      />
    </div>
  );
}

export default Orders;
